<div [class]="'confidence-bar '+class" [matTooltipClass]="{'uzai-tooltip':true}" [matTooltip]="tooltip()">
  <div class="confidence-bar-inner" [style.width.%]="value">
  </div>
</div>